import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import TicketsManager from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";

import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";

const defaultTicketsManagerWidth = 550;
const minTicketsManagerWidth = 404;
const maxTicketsManagerWidth = 700;

const useStyles = makeStyles((theme) => ({
	chatContainer: {
		flex: 1,
		padding: theme.spacing(1.2),
		height: `calc(100% - 54px)`,
		overflowY: "hidden",
		background:
			theme.mode === "light"
				? "linear-gradient(155deg, #f5f9ff 0%, #eef4ff 48%, #f7fbff 100%)"
				: "linear-gradient(155deg, #0f172a 0%, #111827 50%, #1f2937 100%)",
	},
	chatPapper: {
		display: "flex",
		height: "100%",
		borderRadius: 18,
		overflow: "hidden",
		boxShadow:
			theme.mode === "light"
				? "0 16px 35px rgba(15, 23, 42, 0.11)"
				: "0 16px 35px rgba(0, 0, 0, 0.42)",
	},
	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
		position: "relative",
		backgroundColor:
			theme.mode === "light" ? "rgba(255,255,255,0.94)" : "rgba(17,24,39,0.92)",
		backdropFilter: "blur(8px)",
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		flexGrow: 1,
		backgroundColor:
			theme.mode === "light" ? "rgba(255,255,255,0.86)" : "rgba(15,23,42,0.92)",
	},
	welcomeMsg: {
		background:
			theme.mode === "light"
				? "linear-gradient(145deg, #f8fafc 0%, #f1f5f9 50%, #f8fafc 100%)"
				: "linear-gradient(145deg, rgba(15,23,42,0.98) 0%, rgba(17,24,39,0.95) 50%, rgba(15,23,42,0.98) 100%)",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		borderRadius: 14,
		border: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.18)" : "rgba(148,163,184,0.12)"}`,
		margin: theme.spacing(1),
		boxShadow:
			theme.mode === "light"
				? "0 8px 24px rgba(15, 23, 42, 0.06), inset 0 1px 0 rgba(255,255,255,0.8)"
				: "0 8px 24px rgba(0, 0, 0, 0.3)",
		color: theme.palette.text.primary,
	},
	welcomeInner: {
		maxWidth: 380,
		padding: theme.spacing(4),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: theme.spacing(1.5),
	},
	welcomeLogoWrap: {
		display: "flex",
		justifyContent: "center",
		marginBottom: theme.spacing(0.5),
	},
	welcomeTitle: {
		fontSize: "1.05rem",
		fontWeight: 700,
		letterSpacing: "-0.01em",
		color: theme.mode === "light" ? "#0f172a" : "#f1f5f9",
	},
	welcomeText: {
		fontSize: "0.83rem",
		lineHeight: 1.55,
		color: theme.mode === "light" ? "#64748b" : "#94a3b8",
		maxWidth: 280,
	},
	dragger: {
		width: "5px",
		cursor: "ew-resize",
		padding: "4px 0 0",
		borderTop: "1px solid rgba(148,163,184,0.45)",
		position: "absolute",
		top: 0,
		right: -3,
		bottom: 0,
		zIndex: 100,
		background:
			theme.mode === "light"
				? "linear-gradient(180deg, #e8edf5 0%, #dbe4ef 100%)"
				: "linear-gradient(180deg, #243244 0%, #1f2937 100%)",
		userSelect: "none", // Evita a seleção de texto no elemento de redimensionamento
		transition: "all 0.2s ease",
		"&:hover": {
			width: 7,
		},
	},
	logo: {
		logo: theme.logo,
		content: "url(" + (theme.mode === "light" ? theme.calculatedLogoLight() : theme.calculatedLogoDark()) + ")",
		opacity: 0.92,
		filter: theme.mode === "light" ? "none" : "brightness(1.12)",
	},
}));

const TicketsCustom = () => {
	const { user } = useContext(AuthContext);

	const classes = useStyles({ ticketsManagerWidth: user.defaultTicketsManagerWidth || defaultTicketsManagerWidth });

	const { ticketId } = useParams();

	const [ticketsManagerWidth, setTicketsManagerWidth] = useState(0);
	const ticketsManagerWidthRef = useRef(ticketsManagerWidth);

	useEffect(() => {
		if (user && user.defaultTicketsManagerWidth) {
			setTicketsManagerWidth(user.defaultTicketsManagerWidth);
		}
	}, [user]);

	// useEffect(() => {
	// 	if (ticketId && currentTicket.uuid === undefined) {
	// 		history.push("/tickets");
	// 	}
	// }, [ticketId, currentTicket.uuid, history]);

	const handleMouseDown = (e) => {
		document.addEventListener("mouseup", handleMouseUp, true);
		document.addEventListener("mousemove", handleMouseMove, true);
	};
	const handleSaveContact = async value => {
		if (value < 404)
			value = 404
		await api.put(`/users/toggleChangeWidht/${user.id}`, { defaultTicketsManagerWidth: value });

	}
	const handleMouseMove = useCallback(
		(e) => {
			const newWidth = e.clientX - document.body.offsetLeft;
			if (
				newWidth > minTicketsManagerWidth &&
				newWidth < maxTicketsManagerWidth
			) {
				ticketsManagerWidthRef.current = newWidth;
				setTicketsManagerWidth(newWidth);
			}
		},
		[]
	);

	const handleMouseUp = async () => {
		document.removeEventListener("mouseup", handleMouseUp, true);
		document.removeEventListener("mousemove", handleMouseMove, true);

		const newWidth = ticketsManagerWidthRef.current;

		if (newWidth !== ticketsManagerWidth) {
			await handleSaveContact(newWidth);
		}
	};

	return (
		<QueueSelectedProvider>
			<div className={classes.chatContainer}>
				<div className={classes.chatPapper}>
					<div
						className={classes.contactsWrapper}
						style={{ width: ticketsManagerWidth }}
					>
						<TicketsManager />
						<div onMouseDown={e => handleMouseDown(e)} className={classes.dragger} />
					</div>
					<div className={classes.messagesWrapper}>
						{ticketId ? (
							<>
								{/* <Suspense fallback={<CircularProgress />}> */}
								<Ticket />
								{/* </Suspense> */}
							</>
						) : (
							<Hidden only={["sm", "xs"]}>
								<Paper variant="outlined" className={classes.welcomeMsg}>
									<div className={classes.welcomeInner}>
										<div className={classes.welcomeLogoWrap}>
											<img className={classes.logo} width="44%" alt="" />
										</div>
										<div className={classes.welcomeTitle}>Central de Atendimentos</div>
										<div className={classes.welcomeText}>{i18n.t("chat.noTicketMessage")}</div>
									</div>
								</Paper>
							</Hidden>
						)}
					</div>
				</div>
			</div>
		</QueueSelectedProvider>
	);
};

export default TicketsCustom;
